import { PageProvider } from '@/core/context/PageContext';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { useTableFilter } from '@/core/hooks/useTableFilter';
import { GetDetailCourseTopic, GetListCourseTopic } from '../viewmodels';

export const CourseTopicProvider = (props: any) => {
  const {
    courseTopicData: detailCourseTopic,
    actionGetDetailCourseTopic,
    loading: loadingDetail,
    error: errorDetail,
  } = GetDetailCourseTopic();

  const { courseTopicData, actionGetAllCourseTopic, loading, error } = GetListCourseTopic();

  const [currentQueryParameters] = useSearchParams();
  const getId = currentQueryParameters.get('id');

  const { methodFilter } = useTableFilter({
    handleFetchData: actionGetAllCourseTopic,
    querySearch: { search: '' },
    queryFilters: { isActive: undefined },
    queryPagination: { page: 1, limit: 10 },
  });

  const { control, setValue, reset, getValues, watch } = methodFilter;

  useEffect(() => {
    actionGetAllCourseTopic(getValues());
  }, []);

  useEffect(() => {
    if (getId) {
      actionGetDetailCourseTopic(getId);
    }
  }, [getId]);

  const data = {
    detailCourseTopic,
    actionGetDetailCourseTopic,
    loadingDetail,
    errorDetail,
    courseTopicData,
    actionGetAllCourseTopic,
    loading,
    error,
    control,
    setValue,
    reset,
    getValues,
    watch,
  };

  return <PageProvider {...data}>{props.children}</PageProvider>;
};
